import React from 'react';
import PropTypes from 'prop-types';

import { ThumbSlide, ThumbSlideInner, Thumbnail } from '../Carousel.styles';

const Thumb = ({ onClick, selected, slide }) => {
  return (
    <ThumbSlide>
      <ThumbSlideInner aria-labelledby={slide.key} onClick={onClick}>
        <Thumbnail
          fluid={slide.sourceThumbnail}
          alt={slide.alt}
          selected={selected}
        />
      </ThumbSlideInner>
    </ThumbSlide>
  );
};

Thumb.propTypes = {
  onClick: PropTypes.func.isRequired,
  slide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    sourceThumbnail: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  selected: PropTypes.bool,
};
Thumb.defaultProps = {
  selected: false,
};

export default Thumb;
